//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { init } from '../utils/init'
export default {
  name: 'pagination',
  props: {
    paging: {
      type: [Boolean, Object],
      default: false
    }
  },

  data () {
    return {
    }
  },

  computed: {
    pagination () {
      if (typeof (this.paging) === 'boolean') {
        return null
      }
      return init(this.paging)
    }
  },

  watch: {
    data () {
      this.pagination.currentPage = this.paging.currentPage || 1
    }
  },

  methods: {
    handleCurrentChange (value) {
      this.emitPageChange()
    },

    handleSizeChange (value) {
      this.emitPageChange()
    },

    emitPageChange () {
      this.$emit(
        'page-change',
        this.getData()
      )
    },

    getData () {
      return {
        currentPage: this.$refs.pager.internalCurrentPage,
        pageSize: this.$refs.pager.internalPageSize
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tableUnit/components/pagination.vue